import React, { Component } from 'react';
import Dropzone from 'react-dropzone'
import { StyleSheet, css } from 'aphrodite';

import { Flexbox } from './Styles';

import ScenarioPlayer from './ScenarioPlayer';
import Scenario from './models/Scenario';
import ScorePicker from './ScorePicker';

const styles = StyleSheet.create({
  dropzoneStyle: {
    alignSelf: 'center',
    background: 'white'
  },
  dropzoneContentStyle: {
    margin: 10,
    textAlign: 'center'
  }
});

class ScenarioUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scenario: null,
      initialScore: null,
      errors: []
    };
  }

  render() {
    if (this.state.scenario && this.state.initialScore) {
      return <ScenarioPlayer scenario={this.state.scenario} initialScore={this.state.initialScore}/>
    } else if (this.state.errors.length === 0 && this.state.scenario) {
      return(
        <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter)}>
          <div>
            <h2>Scenario</h2>
            <ul>
              <li>{this.state.scenario.actions.length} Actions</li>
              <li>{this.state.scenario.events.length} Events</li>
            </ul>
          </div>
          <ScorePicker onComplete={this.handleInitialScoreSelection.bind(this)} />
        </div>
      );
    } else {
      return(
        <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossFill, Flexbox.fillVertical, styles.container)}>
          <div className={css(styles.dropzoneStyle)}>
            <Dropzone multiple={false} onDrop={this.onDrop.bind(this)}>
              <div className={css(styles.dropzoneContentStyle)}>
                Drop Scenario CSV file here
              </div>
            </Dropzone>
          </div>
          {this.state.errors.length > 0 &&
            <div>
              <h2>Errors</h2>
              <ul>
                {this.state.errors.map(error => {
                  return <li key={error}>{error}</li>
                })}
              </ul>
            </div>
          }
        </div>
      );
    }
  }

  onDrop(acceptedFiles, rejectedFiles) {
    if (!acceptedFiles[0]) {
      this.setState({errors: [`Invalid file: ${rejectedFiles[0].name}`]});
    } else {
      this.setState({errors: []});
      Scenario.loadScenarioFromFile(acceptedFiles[0], (scenario, errors) => {
        this.setState({
          scenario: scenario,
          errors: errors
        });
      });
    }
  }

  handleInitialScoreSelection(score) {
    this.setState({initialScore: score});
  }
}

export default ScenarioUploader;



// WEBPACK FOOTER //
// ./src/ScenarioUploader.js